export enum RouteNames {
  Home = 'Home',
  HouseSize = 'HouseSize',
  RoofShape = 'RoofShape',
  Basement = 'Basement',
  GroundFloor = 'GroundFloor',
  UpperFloor = 'UpperFloor',
  Attic = 'Attic',
  SummaryRoot = 'SummaryRoot',
  Summary = 'Summary',
  SummaryFloor = 'SummaryFloor',
  ContactAppointment = 'ContactAppointment',
  ContactOffer = 'ContactOffer',
  ContactConfirmation = 'ContactConfirmation',
  MobileHome = 'MobileHome',
  Code = 'Code',
  SummaryFloorGroundFloor = 'SummaryFloorGroundFloor',
  SummaryFloorUpperFloor = 'SummaryFloorUpperFloor',
  SummaryFloorAttic = 'SummaryFloorAttic'
}
